import { Platform } from 'react-native';
import GenericModule from '../native/GenericModule';

export const fetchAppVersion = async () => {
  try {
    if (Platform.OS === 'web') {
      return '';
    }
    if (GenericModule) {
      const appVersion = await GenericModule.getAppVersion();
      return appVersion;
    } else {
      return '';
    }
  } catch (e) {
    return '';
  }
};
